import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { from } from 'rxjs';

export const navigateToDetailsProcedure = () => {
  const router = inject(Router);

  return (systemCode: string, id: string, tab?: string, isInbox = false) => {
    const segments = ['module', systemCode, 'details', id];

    if (tab) {
      segments.push(tab);
    }

    const navigation = window.history.state;

    const navigationState: any = {
      previousUrl: navigation?.previousUrl,
    };

    if (isInbox === true) {
      navigationState.isInbox = true;
    }

    const promise = router.navigate(segments, {
      state: navigationState,
    });
    return from(promise);
  };
};
